export const VERSION = 'v3.0.0';
